// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-email-address-contact .email-input {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/utilities/email-address-contacts/email-address-contact/email-address-contact.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":[".fi-email-address-contact {\r\n    .email-input {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
